module.exports = __webpack_public_path__ + "static/media/dior-poison.e2babd59.jpg";